import {
  GET_DMX_DEVICE_PRESET_BY_ID,
  GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS,
  GET_DMX_DEVICE_PRESET_BY_ID_ERROR,
} from './actionTypes';

const initialState = {
  errorGetDmxDevicePresetById: '',
  loadingGetDmxDevicePresetById: false,
  preset: null,
};

const getDevicePresetById = (state = initialState, action) => {
  switch (action.type) {
    case GET_DMX_DEVICE_PRESET_BY_ID:
      state = { ...state, loadingGetDmxDevicePresetById: true };
      break;
    case GET_DMX_DEVICE_PRESET_BY_ID_SUCCESS:
      state = { ...state, loadingGetDmxDevicePresetById: false, preset: action.payload.preset };
      break;
    case GET_DMX_DEVICE_PRESET_BY_ID_ERROR:
      state = { ...state, errorGetDmxDevicePresetById: action.payload, loadingGetDmxDevicePresetById: false };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default getDevicePresetById;
